var _ellipse, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _path5, _circle, _circle2, _circle3, _circle4, _line, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 123,
    viewBox: "0 0 155 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.5,
    cy: 119.5,
    rx: 23.5,
    ry: 3.5,
    fill: "#D2E7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5514 31.0069C19.3197 31.1463 18.7606 31.264 17.8546 31.5745C14.4942 32.7264 11.8815 35.4762 10.9225 38.8704C10.6762 39.7421 10.5066 40.8661 10.5044 41.6408L10.5036 41.9211L10.38 41.8987C9.98973 41.828 9.28242 41.7904 8.7529 41.8122C7.45236 41.8656 6.31518 42.149 5.15626 42.7083C2.6772 43.9047 0.969352 45.9735 0.280814 48.614C-0.0430357 49.8558 -0.0896204 51.3612 0.155865 52.65C0.815591 56.1138 3.51889 58.8798 7.05924 59.7135C7.5117 59.8201 8.18003 59.9226 8.4225 59.9226C8.51803 59.9226 8.60675 59.9397 8.61969 59.9606C8.6528 60.0142 44.0406 60.0126 44.51 59.959C46.912 59.6846 48.9975 58.2782 50.1537 56.153C50.944 54.7004 51.1959 52.8997 50.8455 51.2086C50.4552 49.3256 49.263 47.6012 47.617 46.5391C47.1861 46.261 46.3862 45.8928 45.8801 45.7397C45.2288 45.5426 44.6585 45.4538 43.8725 45.4269L43.1969 45.4038V45.1663C43.1969 44.8268 43.1286 44.205 43.0401 43.7403C42.5684 41.2605 41.0305 39.0288 38.9032 37.7366C36.9374 36.5425 34.5876 36.1228 32.3499 36.5661C31.9609 36.6431 31.3411 36.8021 31.1481 36.8744C31.1255 36.8828 30.9656 36.6509 30.7927 36.359C30.3001 35.5273 29.8369 34.9369 29.0991 34.2002C28.0623 33.165 27.0851 32.4907 25.8024 31.9253C24.3863 31.3013 23.1269 31.028 21.56 31.0048C21.0785 30.9977 20.6247 30.9986 20.5514 31.0069Z",
    fill: "#EBF7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.125 43H128.271C128.209 43 128.155 43.0437 128.142 43.1047L126.033 53.3342C126.016 53.4155 126.078 53.4918 126.161 53.4918H129.906C129.988 53.4918 130.05 53.5675 130.034 53.6487L128.298 62.3279C128.27 62.4697 128.458 62.5463 128.537 62.425L136.754 49.7599C136.81 49.6727 136.748 49.5574 136.644 49.5574H133.137C133.047 49.5574 132.983 49.4673 133.014 49.3818L135.248 43.1756C135.279 43.0901 135.216 43 135.125 43Z",
    fill: "#EBF7FF",
    stroke: "#EBF7FF",
    strokeWidth: 0.131148,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1249 63H22.2708C22.2086 63 22.1549 63.0437 22.1423 63.1047L20.0325 73.3342C20.0157 73.4155 20.0779 73.4918 20.161 73.4918H23.9056C23.9884 73.4918 24.0504 73.5675 24.0342 73.6487L22.2984 82.3279C22.27 82.4697 22.4583 82.5463 22.537 82.425L30.7538 69.7599C30.8105 69.6727 30.7478 69.5574 30.6438 69.5574H27.1374C27.0466 69.5574 26.9833 69.4673 27.014 69.3818L29.2483 63.1756C29.279 63.0901 29.2157 63 29.1249 63Z",
    fill: "#EBF7FF",
    stroke: "#EBF7FF",
    strokeWidth: 0.131148,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.551 10.0071C123.32 10.1514 122.761 10.2731 121.855 10.5943C118.494 11.7859 115.882 14.6305 114.923 18.1417C114.676 19.0436 114.507 20.2064 114.504 21.0077L114.504 21.2977L114.38 21.2745C113.99 21.2014 113.282 21.1625 112.753 21.185C111.452 21.2403 110.315 21.5335 109.156 22.112C106.677 23.3497 104.969 25.4898 104.281 28.2214C103.957 29.506 103.91 31.0633 104.156 32.3965C104.816 35.9798 107.519 38.8411 111.059 39.7036C111.512 39.8139 112.18 39.9199 112.423 39.9199C112.518 39.9199 112.607 39.9376 112.62 39.9593C112.653 40.0147 148.041 40.013 148.51 39.9575C150.912 39.6738 152.997 38.2189 154.154 36.0204C154.944 34.5177 155.196 32.6548 154.845 30.9055C154.455 28.9576 153.263 27.1737 151.617 26.0749C151.186 25.7872 150.386 25.4064 149.88 25.248C149.229 25.0441 148.659 24.9522 147.872 24.9244L147.197 24.9005V24.6547C147.197 24.3036 147.129 23.6604 147.04 23.1796C146.568 20.6144 145.031 18.3056 142.903 16.9689C140.937 15.7336 138.588 15.2994 136.35 15.758C135.961 15.8377 135.341 16.0022 135.148 16.0769C135.126 16.0856 134.966 15.8457 134.793 15.5438C134.3 14.6834 133.837 14.0727 133.099 13.3106C132.062 12.2396 131.085 11.5421 129.802 10.9572C128.386 10.3117 127.127 10.0289 125.56 10.0049C125.079 9.99758 124.625 9.99856 124.551 10.0071Z",
    fill: "#EBF7FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78.8242,
    y: 87.7227,
    width: 13.2759,
    height: 31.8621,
    rx: 5.5,
    fill: "#3C89F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5664,
    y: 87.7227,
    width: 13.2759,
    height: 31.8621,
    rx: 5.5,
    fill: "#3C89F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5664,
    y: 110.293,
    width: 13.2759,
    height: 3.98276,
    fill: "#FF6600"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 78.8242,
    y: 110.293,
    width: 13.2759,
    height: 3.98276,
    fill: "#FF6600"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 23,
    width: 80,
    height: 80,
    rx: 16,
    fill: "#3C89F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0586 91.0312C81.0586 91.0312 79.4425 89.1907 78.0337 89.0146C76.2863 88.7962 74.0004 91.0312 74.0004 91.0312",
    stroke: "#05157B",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.319,
    cy: 85.319,
    r: 3.31897,
    fill: "#5AB3E1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.319,
    cy: 85.319,
    r: 3.31897,
    fill: "#5AB3E1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.198,
    cy: 73.7874,
    r: 5.57414,
    stroke: "#FBFBFB",
    strokeWidth: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.8007,
    cy: 73.7874,
    r: 5.57414,
    stroke: "#FBFBFB",
    strokeWidth: 0.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 74.4012,
    y1: 69.6007,
    x2: 80.6012,
    y2: 69.6007,
    stroke: "#FBFBFB",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7942 74.1263C86.7942 74.1263 85.7961 75.5313 84.5815 75.4505C83.4817 75.3774 82.8114 74.1263 82.8114 74.1263",
    stroke: "#05157B",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1887 74.1263C72.1887 74.1263 71.1906 75.5313 69.9761 75.4505C68.8763 75.3774 68.206 74.1263 68.206 74.1263",
    stroke: "#05157B",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7342 85.2663C86.7342 83.7176 85.7493 82.1688 85.2099 81.4367C85.0415 81.2081 84.7116 81.223 84.5594 81.4627C84.0593 82.2505 83.1138 83.9011 83.0092 85.2663C82.919 86.4436 83.5986 87.4945 84.8665 87.5324C86.172 87.5715 86.7342 86.4816 86.7342 85.2663Z",
    fill: "#EBF7FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.19b2a848910e5a2f30b1455c4e63a3f4.svg";
export { ForwardRef as ReactComponent };